import { Sparkles } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div className="bg-stone-900 py-5 sm:py-6 overflow-hidden" data-testid="marquee-strip">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {items.map((it, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="font-display italic text-2xl sm:text-3xl text-white/90 whitespace-nowrap px-6">
                  {it}
                </span>
                <Sparkles className="w-4 h-4 text-[#E85D75] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
